export const iconFontAwesomeMedicalHealthPager = (
	<i className="fa-solid fa-pager"></i>
);
